<page-heading
  [title]="'report.listImportation.pageTitle' | translate"
  [description]="'report.listImportation.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-lg-6 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'report.listImportation.searchPlaceholder' | translate"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.listImportation.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'report.listImportation.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.listImportation.selectPlaceholder' | translate"
                  >
                    <mat-option value="1">{{ 'report.listImportation.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.listImportation.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.listImportation.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.listImportation.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.listImportation.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="menu"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelFilter | translate }}</span>
              </button>
              <mat-menu #menu class="menu-content">
                <button mat-menu-item (click)="setValueSearch('')">
                  {{ 'report.listImportation.filterAll' | translate }}
                </button>
                <button
                  mat-menu-item
                  (click)="setValueSearch('WAITING', 'report.listImportation.filterWaiting')"
                >
                  {{ 'report.listImportation.filterWaiting' | translate }}
                </button>
                <button
                  mat-menu-item
                  (click)="setValueSearch('RUNNING', 'report.listImportation.filterRunning')"
                >
                  {{ 'report.listImportation.filterRunning' | translate }}
                </button>
                <button
                  mat-menu-item
                  (click)="setValueSearch('DONE', 'report.listImportation.filterDone')"
                >
                  {{ 'report.listImportation.filterDone' | translate }}
                </button>
              </mat-menu>
            </div>

            <div
              class="col-xs-6 col-md-6 col-lg-1 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                [matTooltip]="'report.listImportation.export' | translate"
                (click)="exportFile()"
              >
                <i class="ri-share-box-fill"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if (loadingContent) {
  <content-loading-list />
  } @if (!loadingContent && pager.total === 0) {
  <empty-records-component
    [message]="'report.listImportation.emptyMessage' | translate"
    [subMessage]="'report.listImportation.emptySubMessage' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
  />
  } @if (!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnCreatedAt' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnFile' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnStatus' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnTotalContacts' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnNewContacts' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnUpdatedContacts' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnCreatedTags' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listImportation.columnErrorContacts' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for(item of pager.list; track item) {
        <tr>
          <td>
            <span>
              {{
                item.createdAt
                  | timezoneDate
                    : "DD/MM/YYYY HH:mm"
                    : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <span>
              <a [href]="item.url" download style="cursor: pointer">
                {{ item.filename }}
              </a>
            </span>
          </td>
          <td>
            <span>
              {{ getStatus(item.status) }}
            </span>
          </td>
          <td>
            <span>
              {{ item.metadata?.totalSend }}
            </span>
          </td>
          <td>
            <span>
              {{ item.metadata?.totalInserted }}
            </span>
          </td>
          <td>
            <span>
              {{ item.metadata?.totalUpdated }}
            </span>
          </td>
          <td>
            <span>
              {{ item.metadata?.totalCreatedTag }}
            </span>
          </td>
          <td>
            <span>
              {{ item.metadata?.totalError }}
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
    }
  </div>
  }
</div>
